export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGOUT = "USER_LOGOUT";

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";

export const USER_DATA_REQUEST = "USER_DATA_REQUEST";
export const USER_DATA_SUCCESS = "USER_DATA_SUCCESS";
export const USER_DATA_FAIL = "USER_DATA_FAIL";


export const ADD_PROPERTY_REQUEST = "ADD_PROPERTY_REQUEST";
export const ADD_PROPERTY_SUCCESS = "ADD_PROPERTY_SUCCESS";
export const ADD_PROPERTY_FAIL = "ADD_PROPERTY_FAIL";

export const GET_PROPERTIES_REQUEST = "GET_PROPERTIES_REQUEST";
export const GET_PROPERTIES_SUCCESS = "GET_PROPERTIES_SUCCESS";
export const GET_PROPERTIES_FAIL = "GET_PROPERTIES_FAIL";


export const GET_USER_PROPERTIES_REQUEST = "GET_USER_PROPERTIES_REQUEST";
export const GET_USER_PROPERTIES_SUCCESS = "GET_USER_PROPERTIES_SUCCESS";
export const GET_USER_PROPERTIES_FAIL = "GET_USER_PROPERTIES_FAIL";

export const DELETE_PROPERTY_REQUEST = "DELETE_PROPERTY_REQUEST";
export const DELETE_PROPERTY_SUCCESS = "DELETE_PROPERTY_SUCCESS";
export const DELETE_PROPERTY_FAIL = "DELETE_PROPERTY_FAIL";

export const UPDATE_PROPERTY_REQUEST = "UPDATE_PROPERTY_REQUEST";
export const UPDATE_PROPERTY_SUCCESS = "UPDATE_PROPERTY_SUCCESS";
export const UPDATE_PROPERTY_FAIL = "UPDATE_PROPERTY_FAIL";

export const GET_PROPDETAILS_REQUEST = "GET_PROPDETAILS_REQUEST";
export const GET_PROPDETAILS_SUCCESS = "GET_PROPDETAILS_SUCCESS";
export const GET_PROPDETAILS_FAIL = "GET_PROPDETAILS_FAIL";


export const FORGOTPASS_REQUEST = "FORGOTPASS_REQUEST";
export const FORGOTPASS_SUCCESS = "FORGOTPASS_SUCCESS";
export const FORGOTPASS_FAIL = "FORGOTPASS_FAIL";

export const RESETPASS_REQUEST = "RESETPASS_REQUEST";
export const RESETPASS_SUCCESS = "RESETPASS_SUCCESS";
export const RESETPASS_FAIL = "RESETPASS_FAIL";


export const MEET_REQUEST = "MEET_REQUEST";
export const MEET_SUCCESS = "MEET_SUCCESS";
export const MEET_FAIL = "MEET_FAIL";

export const FETCH_CREATER_MEET_REQUEST = "FETCH_MEET_REQUEST";
export const FETCH_CREATER_MEET_SUCCESS = "FETCH_MEET_SUCCESS";
export const FETCH_CREATER_MEET_FAIL = "FETCH_MEET_FAIL";

export const FETCH_RECIEVER_MEET_REQUEST = "FETCH_MEET_REQUEST";
export const FETCH_RECIEVER_MEET_SUCCESS = "FETCH_MEET_SUCCESS";
export const FETCH_RECIEVER_MEET_FAIL = "FETCH_MEET_FAIL";